import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26;

import { computed, makeObservable, observable, runInAction } from "mobx";
import * as yup from "yup";

var _SCHEMA = yup.object({
  gifteeEmail: yup.string().email("Please enter a valid email for the giftee").required("Please enter the giftee's email"),
  recipientFirstName: yup.string().required("Please enter the recipient's first name"),
  recipientLastName: yup.string().required("Please enter the recipient's last name"),
  recipientLockerID: yup.number().required("Please enter the recipient's locker ID"),
  gifterUserID: yup.number().required("Please enter the gifter's user ID"),
  lockerID: yup.number().required("Please enter the locker ID"),
  giftMessage: yup.string().required("Please enter the gift message"),
  keyHolderFirstName: yup.string().max(32, "Max. characters allowed are 32").min(2, "Min. 2 characters required").required("This field is mandatory"),
  keyHolderLastName: yup.string().min(2, "Min. 2 characters required").max(32, "Max. characters allowed are 32").required("This field is mandatory"),
  keyHolderEmail: yup.string().email("Please enter a valid email").required("Please enter a valid email")
});

export var WineLockerModel = (_class = /*#__PURE__*/function () {
  // Gift a wine variables
  function WineLockerModel() {
    _classCallCheck(this, WineLockerModel);

    _initializerDefineProperty(this, "_wineLockerDetails", _descriptor, this);

    _initializerDefineProperty(this, "_wineLockersByOwner", _descriptor2, this);

    _initializerDefineProperty(this, "_wineLockersByLocation", _descriptor3, this);

    _initializerDefineProperty(this, "_guestAuthDetails", _descriptor4, this);

    _initializerDefineProperty(this, "_hasLockerAtCurrentLocation", _descriptor5, this);

    _initializerDefineProperty(this, "_selectedWinesForGift", _descriptor6, this);

    _initializerDefineProperty(this, "_gifteeEmailForGift", _descriptor7, this);

    _initializerDefineProperty(this, "_recipientFirstNameForGift", _descriptor8, this);

    _initializerDefineProperty(this, "_recipientLastNameForGift", _descriptor9, this);

    _initializerDefineProperty(this, "_recipientLockerIDForGift", _descriptor10, this);

    _initializerDefineProperty(this, "_giftMessageForGift", _descriptor11, this);

    _initializerDefineProperty(this, "_keyHolderFirstName", _descriptor12, this);

    _initializerDefineProperty(this, "_keyHolderLastName", _descriptor13, this);

    _initializerDefineProperty(this, "_keyHolderEmail", _descriptor14, this);

    _initializerDefineProperty(this, "_updatingKeyHolder", _descriptor15, this);

    _initializerDefineProperty(this, "_lockerAllHistory", _descriptor16, this);

    _initializerDefineProperty(this, "_lockerConsumedHistory", _descriptor17, this);

    _initializerDefineProperty(this, "_lockerPurchasedHistory", _descriptor18, this);

    _initializerDefineProperty(this, "_lockerSentGifts", _descriptor19, this);

    _initializerDefineProperty(this, "_lockerHistoryActiveTab", _descriptor20, this);

    _initializerDefineProperty(this, "_wineLockerLoading", _descriptor21, this);

    _initializerDefineProperty(this, "_lockerReceivedGifts", _descriptor22, this);

    _initializerDefineProperty(this, "_addRecipientSearchText", _descriptor23, this);

    _initializerDefineProperty(this, "_searchedWineLockers", _descriptor24, this);

    _initializerDefineProperty(this, "_loading", _descriptor25, this);

    _initializerDefineProperty(this, "_addRecipientActiveSection", _descriptor26, this); // BRING BACK AFTER ADDING OBSERVABLES


    makeObservable(this);
  }

  _createClass(WineLockerModel, [{
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "resetKeyholder",
    value: function resetKeyholder() {
      var _this = this;

      runInAction(function () {
        _this._keyHolderEmail = "";
        _this._keyHolderFirstName = "";
        _this._keyHolderLastName = "";
      });
    }
  }, {
    key: "filterWineLockers",
    value: function filterWineLockers() {
      var _this$wineLockersByLo,
          _this2 = this;

      var filteredLockers = (_this$wineLockersByLo = this.wineLockersByLocation) === null || _this$wineLockersByLo === void 0 ? void 0 : _this$wineLockersByLo.lockers.filter(function (locker) {
        if (locker.visibility !== "Public") {
          return false;
        }

        var wineLockerNameString = locker.name.toLowerCase();

        if (wineLockerNameString.includes(_this2.addRecipientSearchText.toLowerCase())) {
          return true;
        }

        return false;
      });
      this.searchedWineLockers = filteredLockers.length > 0 ? filteredLockers : [];
      this.loading = false;
    }
  }, {
    key: "resetGiftAWine",
    value: function resetGiftAWine() {
      var _this3 = this;

      runInAction(function () {
        _this3._selectedWinesForGift = {};
        _this3._gifteeEmailForGift = null;
        _this3._recipientFirstNameForGift = null;
        _this3._recipientLastNameForGift = null;
        _this3._giftMessageForGift = null;
        _this3._recipientLockerIDForGift = null;
        _this3._addRecipientSearchText = null;
        _this3._searchedWineLockers = [];
        _this3._addRecipientActiveSection = "EMAIL";
      });
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "guestAuthDetails",
    set: function set(response) {
      var _this4 = this;

      runInAction(function () {
        _this4._guestAuthDetails = response;
      });
    },
    get: function get() {
      return this._guestAuthDetails;
    }
  }, {
    key: "wineLockerDetails",
    set: function set(response) {
      var _this5 = this;

      runInAction(function () {
        _this5._wineLockerDetails = response;
      });
    },
    get: function get() {
      return this._wineLockerDetails;
    }
  }, {
    key: "wineLockersByOwner",
    set: function set(response) {
      var _this6 = this;

      runInAction(function () {
        _this6._wineLockersByOwner = response;
      });
    },
    get: function get() {
      return this._wineLockersByOwner;
    }
  }, {
    key: "wineLockersByLocation",
    set: function set(response) {
      var _this7 = this;

      runInAction(function () {
        _this7._wineLockersByLocation = response;
      });
    },
    get: function get() {
      return this._wineLockersByLocation;
    }
  }, {
    key: "hasLockerAtCurrentLocation",
    set: function set(response) {
      var _this8 = this;

      runInAction(function () {
        _this8._hasLockerAtCurrentLocation = response;
      });
    },
    get: function get() {
      return this._hasLockerAtCurrentLocation;
    }
  }, {
    key: "selectedWinesForGift",
    get: function get() {
      return this._selectedWinesForGift;
    },
    set: function set(wines) {
      var _this9 = this;

      runInAction(function () {
        _this9._selectedWinesForGift = wines;
      });
    }
  }, {
    key: "keyHolderFirstName",
    get: function get() {
      return this._keyHolderFirstName;
    },
    set: function set(userFirstName) {
      var _this10 = this;

      runInAction(function () {
        _this10._keyHolderFirstName = userFirstName;
      });
    }
  }, {
    key: "keyHolderLastName",
    get: function get() {
      return this._keyHolderLastName;
    },
    set: function set(userFirstName) {
      var _this11 = this;

      runInAction(function () {
        _this11._keyHolderLastName = userFirstName;
      });
    }
  }, {
    key: "keyHolderEmail",
    get: function get() {
      return this._keyHolderEmail;
    },
    set: function set(userFirstName) {
      var _this12 = this;

      runInAction(function () {
        _this12._keyHolderEmail = userFirstName;
      });
    }
  }, {
    key: "updatingKeyHolder",
    get: function get() {
      return this._updatingKeyHolder;
    },
    set: function set(loading) {
      var _this13 = this;

      runInAction(function () {
        _this13._updatingKeyHolder = loading;
      });
    }
  }, {
    key: "wineLockerLoading",
    get: function get() {
      return this._wineLockerLoading;
    },
    set: function set(loading) {
      var _this14 = this;

      runInAction(function () {
        _this14._wineLockerLoading = loading;
      });
    }
  }, {
    key: "gifteeEmail",
    get: function get() {
      return this._gifteeEmailForGift;
    },
    set: function set(email) {
      var _this15 = this;

      runInAction(function () {
        _this15._gifteeEmailForGift = email;
      });
    }
  }, {
    key: "recipientFirstName",
    get: function get() {
      return this._recipientFirstNameForGift;
    },
    set: function set(firstName) {
      var _this16 = this;

      runInAction(function () {
        _this16._recipientFirstNameForGift = firstName;
      });
    }
  }, {
    key: "recipientLastName",
    get: function get() {
      return this._recipientLastNameForGift;
    },
    set: function set(lastName) {
      var _this17 = this;

      runInAction(function () {
        _this17._recipientLastNameForGift = lastName;
      });
    }
  }, {
    key: "recipientLockerID",
    get: function get() {
      return this._recipientLockerIDForGift;
    },
    set: function set(lockerID) {
      var _this18 = this;

      runInAction(function () {
        _this18._recipientLockerIDForGift = lockerID;
      });
    }
  }, {
    key: "giftMessage",
    get: function get() {
      return this._giftMessageForGift;
    },
    set: function set(message) {
      var _this19 = this;

      runInAction(function () {
        _this19._giftMessageForGift = message;
      });
    }
  }, {
    key: "lockerHistoryActiveTab",
    get: function get() {
      return this._lockerHistoryActiveTab;
    },
    set: function set(activeTab) {
      var _this20 = this;

      runInAction(function () {
        _this20._lockerHistoryActiveTab = activeTab;
      });
    }
  }, {
    key: "lockerAllHistory",
    get: function get() {
      return this._lockerAllHistory;
    },
    set: function set(history) {
      var _this21 = this;

      runInAction(function () {
        _this21._lockerAllHistory = history;
      });
    }
  }, {
    key: "lockerConsumedHistory",
    get: function get() {
      return this._lockerConsumedHistory;
    },
    set: function set(history) {
      var _this22 = this;

      runInAction(function () {
        _this22._lockerConsumedHistory = history;
      });
    }
  }, {
    key: "lockerPurchasedHistory",
    get: function get() {
      return this._lockerPurchasedHistory;
    },
    set: function set(history) {
      var _this23 = this;

      runInAction(function () {
        _this23._lockerPurchasedHistory = history;
      });
    }
  }, {
    key: "lockerSentGifts",
    get: function get() {
      return this._lockerSentGifts;
    },
    set: function set(history) {
      var _this24 = this;

      runInAction(function () {
        _this24._lockerSentGifts = history;
      });
    }
  }, {
    key: "lockerReceivedGifts",
    get: function get() {
      return this._lockerReceivedGifts;
    },
    set: function set(gifts) {
      var _this25 = this;

      runInAction(function () {
        _this25._lockerReceivedGifts = gifts;
      });
    }
  }, {
    key: "addRecipientSearchText",
    get: function get() {
      return this._addRecipientSearchText;
    },
    set: function set(text) {
      var _this26 = this;

      runInAction(function () {
        _this26._addRecipientSearchText = text;
      });
    }
  }, {
    key: "searchedWineLockers",
    get: function get() {
      return this._searchedWineLockers;
    },
    set: function set(wineLockers) {
      var _this27 = this;

      runInAction(function () {
        _this27._searchedWineLockers = wineLockers;
      });
    }
  }, {
    key: "loading",
    get: function get() {
      return this._loading;
    },
    set: function set(loading) {
      var _this28 = this;

      runInAction(function () {
        _this28._loading = loading;
      });
    }
  }, {
    key: "addRecipientActiveSection",
    get: function get() {
      return this._addRecipientActiveSection;
    },
    set: function set(section) {
      var _this29 = this;

      runInAction(function () {
        _this29._addRecipientActiveSection = section;
      });
    }
  }]);

  return WineLockerModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_wineLockerDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_wineLockersByOwner", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_wineLockersByLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_guestAuthDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_hasLockerAtCurrentLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_selectedWinesForGift", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_gifteeEmailForGift", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_recipientFirstNameForGift", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_recipientLastNameForGift", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_recipientLockerIDForGift", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_giftMessageForGift", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_keyHolderFirstName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_keyHolderLastName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_keyHolderEmail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_updatingKeyHolder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_lockerAllHistory", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_lockerConsumedHistory", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_lockerPurchasedHistory", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_lockerSentGifts", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_lockerHistoryActiveTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "ALL";
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_wineLockerLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_lockerReceivedGifts", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_addRecipientSearchText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_searchedWineLockers", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_loading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_addRecipientActiveSection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "EMAIL";
  }
}), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyHolderFirstName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "keyHolderFirstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyHolderLastName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "keyHolderLastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyHolderEmail", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "keyHolderEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updatingKeyHolder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "updatingKeyHolder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wineLockerLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "wineLockerLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lockerHistoryActiveTab", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lockerHistoryActiveTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lockerAllHistory", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lockerAllHistory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lockerConsumedHistory", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lockerConsumedHistory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lockerPurchasedHistory", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lockerPurchasedHistory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lockerSentGifts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lockerSentGifts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lockerReceivedGifts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lockerReceivedGifts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addRecipientSearchText", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "addRecipientSearchText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchedWineLockers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchedWineLockers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "loading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addRecipientActiveSection", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "addRecipientActiveSection"), _class.prototype)), _class);